module.exports = __webpack_public_path__ + "img/examBgList2.8088e4a5.png";